import {Component, Inject} from '@angular/core';
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {GameService} from "../../../services/game.service";
import {ActiveUserService} from "../../../services/active-user.service";
import {SnackbarService} from "../../../services/snackbar.service";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {NgIf} from "@angular/common";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {IUpdateNotificationDeliverySettings} from "../../../interfaces/IUpdateNotificationDeliverySettings";
import {DRAW_REMINDER_DELIVERY_INVALID_ERROR_TYPE, DRAW_REMINDER_DELIVERY_INVALID_MESSAGE} from "../../../consts/DrawReminderSettingsErrors";

// Send rate for draw reminders: players are split into chunks of NotificationChunkSize, one chunk every
// NotificationFrequency seconds. A pair that cannot fit the reminder window sends no reminders at all.
@Component({
  selector: 'app-edit-notification-delivery-settings',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatHint,
    ReactiveFormsModule,
    MatButton,
    NgIf
  ],
  templateUrl: './edit-notification-delivery-settings.component.html'
})
export class EditNotificationDeliverySettingsComponent {

  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;

  public notificationFrequencyControl = new FormControl<number | null>(3600, [Validators.required, Validators.min(1)]);
  public notificationChunkSizeControl = new FormControl<number | null>(100, [Validators.required, Validators.min(1)]);

  public notificationDeliverySettingsForm = new FormGroup({
    notificationFrequency: this.notificationFrequencyControl,
    notificationChunkSize: this.notificationChunkSizeControl
  });

  constructor(private dialogRef: MatDialogRef<EditNotificationDeliverySettingsComponent>,
              private gameService: GameService,
              private activeUserService: ActiveUserService,
              @Inject(MAT_DIALOG_DATA) public game: IGameQueryResult,
              private snackBarService: SnackbarService) {
    this.notificationFrequencyControl.setValue(this.game.NotificationFrequency);
    this.notificationChunkSizeControl.setValue(this.game.NotificationChunkSize);
  }

  submit() {
    if (this.notificationDeliverySettingsForm.invalid) {
      this.notificationDeliverySettingsForm.markAllAsTouched();
      return;
    }

    this.uiState = UIStateEnum.ShowLoading;

    const command: IUpdateNotificationDeliverySettings = {
      AdminId: this.activeUserService.activeUser().Id,
      GameId: this.game.Id,
      NotificationFrequency: this.notificationFrequencyControl.value!,
      NotificationChunkSize: this.notificationChunkSizeControl.value!
    };

    this.gameService.updateGameNotificationDeliverySettings(command).subscribe({
      next: () => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openSuccessfulSnackBar("Successfully updated notification delivery settings!");
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openErrorSnackBar(err?.Error?.ErrorType === DRAW_REMINDER_DELIVERY_INVALID_ERROR_TYPE
          ? DRAW_REMINDER_DELIVERY_INVALID_MESSAGE
          : "Failed to update notification delivery settings!");
      }
    });
  }
}
